import { BLOCKS } from '@contentful/rich-text-types'
export default {
  [BLOCKS.QUOTE]: ({ content }, key, h, next) =>
    h('blockquote', { key }, next(content, key, h, next)),
}
